/*
*
* File JS componente Header
*
*/

// IMPORT MODULES
//--------------------------------------------------------------------//

import Headroom from "headroom.js";

// IMPORT ATOMS
//--------------------------------------------------------------------//
import searchBar from "components/search-bar/search-bar";
import topBarInit from "components/top-bar/top-bar";

 
// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './header.scss';

//--------------------------------------------------------------------//


/**
*	Script per il componente Header
*
*
*	@since  0.0.2
*	@author Guccy - IM*MEDIA
*
*	@return {void}
*/
const header = () =>
{

    /* Individuiamo dal DOM tutti gli elementi dell'header
    --------------------------------------------------------------------------*/
    const context = document.querySelector('#header');
    if( context === null ) return false;

    const navExpand = 1100;

    // /* Menu e megamenu
    // --------------------------------------------------------------------------*/
    const burgermenu = context.querySelector('.header__burger');

    /*/ Al click sul Burgermenu
    --------------------------------------------------------------------------*/
    if( burgermenu )
    {
        burgermenu.addEventListener('click', e=>
        {
            context.classList.toggle('mainmenu-opened');
        });
    }


    // /* Menu DropDown
    // --------------------------------------------------------------------------*/
    const subMenus  = context.querySelectorAll('.header__menu > ul > li.dropdown');
    const iconDropdown = '<div class="submenu-indicator"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" shape-rendering="geometricPrecision" class="icons-open-down"><use xlink:href="' + templateUrl + '/assets/build/spritemap.svg#ico_down"></use></svg></div>';


    /*/ Funzione di apertura del submenu
    // --------------------------------------------------------------------------*/
    function openSubMenu(el)
    {
        el.classList.add('open');
        context.classList.add('submenu-opened');

        let paddingSubMenu = 20;
        let heightSubmenu = 0;
        let elementsInSub = el.querySelectorAll(':scope > .dropdown-menu > li');

        //Nel caso di NavExpand
        if (window.innerWidth > navExpand)
        {
            paddingSubMenu = 40;
        }

        //Calcolo per dare l'altezza al subMenu
        elementsInSub.forEach(element => 
        {
            heightSubmenu = heightSubmenu + element.offsetHeight;
        });

        el.querySelector(':scope > .dropdown-menu').style.height = (heightSubmenu + paddingSubMenu) + 'px';
       
    }

    /*/ Funzione di chiusa del submenu
    // --------------------------------------------------------------------------*/
    
    function closeSubMenu(el)
    {
        el.classList.remove('open');
        context.classList.remove('submenu-opened');

        //Nel caso di NavCompressed
        // if (window.innerWidth < navExpand)
        // {
            el.querySelector(':scope > .dropdown-menu').style.height = '';
        //}
    }

    /*/ Aggiunta di EvetListner + Icona a tutti i subMenus
    // --------------------------------------------------------------------------*/

    subMenus.forEach((item, i) => {
        // Add icon dropdown
        item.firstElementChild.innerHTML += iconDropdown;

        item.addEventListener('click', () => {

        // Chiudi tutti i submenu tranne quello attuale
        subMenus.forEach((submenu, index) => {
            if (index !== i && submenu.classList.contains('open')) {
                closeSubMenu(submenu);
            }
        });

        // Toggle del sottomenu attuale
        item.classList.contains('open') ? closeSubMenu(item) : openSubMenu(item); 
        });
    
    });

    /*/ chiudi tutti i submenu aperti Se si il clicca al di fuori
    // --------------------------------------------------------------------------*/
    function closeSubMenuByClickOut()
    {
        
        const subMenusArray = Array.from(subMenus);

        document.addEventListener('click', (event) => {
            const clickedElement = event.target;
    
            const isLinkWithSubMenu = subMenusArray.some(submenu => submenu.contains(clickedElement));
    
            if (!isLinkWithSubMenu) {
                for (let i = 0; i < subMenusArray.length; i++) {
                    closeSubMenu(subMenusArray[i]);
                }
            }
        });
    }

    //Usa la funzione solo su navexpanded
    if (window.innerWidth > navExpand)
    {
        closeSubMenuByClickOut();
    }

    // --------------------------------------------------------------------------*/
    
   
    /*/ Funzione di Headroom
    // --------------------------------------------------------------------------*/
    const headroom = new Headroom(context);
    headroom.init();
    

    searchBar();
    topBarInit();
}


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

export default header;

//--------------------------------------------------------------------//